export default __webpack_public_path__ + "static/media/earnings.30d0ce38.svg";